// extracted by mini-css-extract-plugin
export var errorIcon = "_p5-1";
export var nameLogo = "_p5-0";